import { useState } from 'react';
import { fetcher } from '@utils/data-fetching/fetcher';
import type { ManualStatusType } from '@components/features/screening/screening.types';

interface UpdateManualStatusParams {
  jobId: number;
  phone: string;
  manualStatus: ManualStatusType;
}

/**
 * Hook to update manual candidate status
 * Uses POST /v1/screening/screening/manual-candidate-status
 */
export const useUpdateManualStatus = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updateStatus = async (params: UpdateManualStatusParams): Promise<boolean> => {
    setIsLoading(true);
    setError(null);

    try {
      await fetcher(
        '/v1/screening/screening/manual-candidate-status',
        undefined,
        {
          method: 'POST',
          payload: {
            jobId: params.jobId,
            phone: params.phone,
            manualStatus: params.manualStatus,
          },
          stringifyPayload: true,
          headers: {
            'Content-Type': 'application/json',
          },
          expectEmptyResponse: true, // 204 No Content response
        },
      );
      return true;
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to update status'));
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateStatus,
    isLoading,
    error,
  };
};

export default useUpdateManualStatus;
